export default '/pricing/deals';
